import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import React from "react";
import { useTranslation } from "react-i18next";
import "./Aresure.css";

const Deletepopup = ({
  isOpen,
  setisOpen,
  handledelete,
  onClose,
  title,
  description,
  confirmLabel,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={isOpen}
      onClose={() => setisOpen(false)}
      aria-labelledby="delete-confirm-title"
      aria-describedby={description ? "delete-confirm-desc" : "delete-confirm-title"}
      className="delete-confirm-modal"
    >
      <Box className="delete-confirm-dialog" role="dialog" aria-modal="true">
        <h2 id="delete-confirm-title" className="delete-confirm-dialog__title">
          {title || t("aresure")}
        </h2>
        {description ? (
          <p id="delete-confirm-desc" className="delete-confirm-dialog__body">
            {description}
          </p>
        ) : null}
        <div className="delete-confirm-dialog__actions">
          <button
            type="button"
            className="delete-confirm-dialog__btn delete-confirm-dialog__btn--cancel"
            onClick={onClose}
          >
            {t("cancel")}
          </button>
          <button
            type="button"
            className="delete-confirm-dialog__btn delete-confirm-dialog__btn--delete"
            onClick={handledelete}
          >
            {confirmLabel || t("delete")}
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default Deletepopup;
